import Styles from './NSHChanges.module.css';
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";

export interface NSHChangesProps 
{
    old_value: string;
    new_value: string;
}

function NSHChanges(props: NSHChangesProps)
{
    const highlightSyntax = (str: string) => 
    {
        return (
            <pre
                style={{ display: "inline" }}
                dangerouslySetInnerHTML={{
                    __html: str.replace(/High/, '<span style="color: rgb(255 63 63)">$&</span>')
                }}
            />
        );
    };

    return (
        <div className={Styles.nsh_pre_tag}>
            <ReactDiffViewer
                oldValue={props.old_value}
                newValue={props.new_value}
                splitView={false}
                hideLineNumbers={true}
                renderContent={highlightSyntax}
                compareMethod={DiffMethod.JSON}
                styles={{
                    diffRemoved: { backgroundColor: "rgba(255, 40, 20, 0.8)" },
                    diffAdded: { backgroundColor: "rgba(100, 200, 95, 1)" },
                    codeFoldGutter: { backgroundColor: "white" },
                    gutter: { backgroundColor: "rgba(161, 164, 176, 1)", textAlign: "center" },
                    codeFold: { backgroundColor: "white" },
                }}
            />
        </div>
    );
}

export default NSHChanges;